var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.service)?_c('div',{staticClass:"mt-2"},[_c('a',{staticClass:"btn btn-info",attrs:{"href":_vm.link}},[_vm._v("\n      "+_vm._s(_vm._f("setText")("do_price","Сделать оценку")))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }